import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  TransportPlannerProfileListState,
  TransportPlannerProfileListStateModel,
} from './transport-planner-profile-list.state';
import {
  TransportPlannerProfileListInitialState,
  TransportPlannerProfileListLoad,
} from './transport-planner-profile-list.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ListSearchCriteriaFacade } from '../../../list-search-criteria/list-search-criteria.facade';
import { PlannerProfile, PlannerProfileListSearchCriteria } from '../../../../models';
import { ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class TransportPlannerProfileListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<TransportPlannerProfileListStateModel> = this.store.select(
    TransportPlannerProfileListState.getState,
  );
  items$: Observable<PlannerProfile[]> = this.store.select(TransportPlannerProfileListState.getItems);
  loaded$: Observable<boolean> = this.store.select(TransportPlannerProfileListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.TransportPlannerProfiles)
      .subscribe((searchCriteria: PlannerProfileListSearchCriteria) => {
        this.store.dispatch(new TransportPlannerProfileListLoad(searchCriteria));
      });
  }

  loadListForDialog(searchCriteria: PlannerProfileListSearchCriteria): void {
    this.store.dispatch(new TransportPlannerProfileListLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportPlannerProfileListInitialState());
  }
}
